export default __webpack_public_path__ + "static/media/mobile-pic.b6d0ae69.png";